import { Col } from "react-bootstrap";
import { BsLink45Deg } from "react-icons/bs";

export const ProjectCard = ({ title, description, imgUrl, link = "" }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt="project" />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          {link !== "" && (
            <button onClick={() => window.open(link, "_blank")}>
              Visit site <BsLink45Deg size={20} color="white" />
            </button>
          )}
        </div>
      </div>
    </Col>
  );
};
